module.exports = __webpack_public_path__ + "img/wordpress-wine.de9102b9.png";